// VPNDetector.jsx

import { useEffect, useState } from "react";
import "../../styles/navbar/VPNDetector.css";

const API_BASE = "https://api.anti-bot.ai";

const COUNTRY_NAME = {
  RU:"רוסיה", CN:"סין", IR:"איראן", KP:"צ. קוריאה",
  BY:"בלארוס", UA:"אוקראינה", US:"ארה״ב", DE:"גרמניה",
  GB:"בריטניה", FR:"צרפת", NL:"הולנד", PL:"פולין",
  CH:"שווייץ", JP:"יפן", RO:"רומניה", BG:"בולגריה",
  IL:"ישראל", SA:"סעודיה", TR:"טורקיה", EG:"מצרים",
};

const STATUS_COLOR = {
  "חשוד גבוה": "#ff2244",
  "נחשף":      "#ff8c00",
  "חשוד":      "#ffd700",
};

export default function VPNDetector() {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res  = await fetch(`${API_BASE}/api/cyber/vpn-detection`);
        const json = await res.json();
        if (json.success) setData(json);
      } catch (err) {
        console.error("VPNDetector fetch error:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const stats = data?.stats;

  return (
    <div className="vpn-page">

      <div className="vpn-header">
        <span className="vpn-title">זיהוי כתובות IP של בוטים</span>
      </div>

      {loading ? (
        <div className="vpn-loading">טוען נתונים...</div>
      ) : (
        <>
          {/* ── Stats ── */}
          <div className="vpn-stats">
            <div className="vpn-stat-box">
              <span className="vpn-stat-val cyan">{stats?.total ?? "—"}</span>
              <span className="vpn-stat-lbl">סה"כ בוטים עם IP</span>
            </div>
            <div className="vpn-stat-box">
              <span className="vpn-stat-val red">{stats?.blocked ?? "—"}</span>
              <span className="vpn-stat-lbl">חשוד גבוה (ציון 70+)</span>
            </div>
            <div className="vpn-stat-box">
              <span className="vpn-stat-val orange">{stats?.exposed ?? "—"}</span>
              <span className="vpn-stat-lbl">נחשפו (ציון 55-70)</span>
            </div>
            <div className="vpn-stat-box">
              <span className="vpn-stat-val yellow">{stats?.suspected ?? "—"}</span>
              <span className="vpn-stat-lbl">חשודים (ציון מתחת 55)</span>
            </div>
          </div>

          {/* ── טבלה ── */}
          <div className="vpn-section">
            <div className="vpn-section-title">
              <span>נתוני IP של בוטים שזוהו</span>
              <span className="vpn-updated">
                {data?.last_analyzed
                  ? `עודכן: ${new Date(data.last_analyzed).toLocaleString('he-IL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}`
                  : "—"}
              </span>
            </div>

            <div className="vpn-table-wrap">
              <table className="vpn-table">
                <thead>
                  <tr>
                    <th>סטטוס</th>
                    <th>שם משתמש</th>
                    <th>כתובת IP</th>
                    <th>מיקום מוצהר בטוויטר</th>
                    <th>מדינה לפי IP</th>
                    <th>סוג בוט</th>
                    <th>ציון</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.bots?.map((row, i) => {
                    const color = STATUS_COLOR[row.status] || "#ffd700";
                    const countryLower = (row.country_code || '').toLowerCase();
                    return (
                      <tr key={i}>
                        <td>
                          <span className="vpn-badge" style={{
                            background: `${color}22`,
                            color,
                            border: `1px solid ${color}66`
                          }}>
                            {row.status}
                          </span>
                        </td>
                        <td style={{ color: '#D89B5A', fontWeight: 600 }}>
                          @{row.username}
                        </td>
                        <td className="vpn-ip" style={{ color: '#E2A869' }}>
                          {row.ip}
                        </td>
                        <td style={{ color: '#B7A99A' }}>
                          {row.location}
                        </td>
                        <td>
                          <div className="vpn-country">
                            {countryLower && (
                              <img src={`https://flagcdn.com/16x12/${countryLower}.png`} alt="" />
                            )}
                            {COUNTRY_NAME[row.country_code] || row.country_code}
                          </div>
                        </td>
                        <td style={{ color: '#B7A99A', fontSize: '12px' }}>
                          {row.bot_type}
                        </td>
                        <td style={{ color: color, fontWeight: 700, fontFamily: 'monospace' }}>
                          {row.bot_score}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
